<template>
  <div class="nuttrema-index-list__content__list">
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
// import { TweenMax, ScrollToPlugin } from 'gsap';
export default {
  name: 'nuttrema-index-list-content',
  props: {
    scrollTargetID: {
      required: false,
    },
  },
  methods: {
    getWindowRelativeOffset(parentWindow, elem) {
      const offset = {
        left: 0,
        top: 0,
      };

      // relative to the target field's document
      offset.left = elem.getBoundingClientRect().left;
      offset.top = elem.getBoundingClientRect().top;

      // now we will calculate according to the current document, this current
      // document might be same as the document of target field or it may be
      // parent of the document of the target field
      let childWindow = elem;

      while (childWindow !== parentWindow) {
        offset.left += childWindow.getBoundingClientRect().left;
        offset.top += childWindow.getBoundingClientRect().top;
        childWindow = childWindow.parent;
      }

      return offset;
    },
    findAnchorAndTriggerScroll() {
      const anchor = this.$el.querySelector(`[id=nuttrema-table-row-${this.scrollTargetID}]`);
      if (anchor) {
        const rectParent = this.$el.getBoundingClientRect();
        const rectAnchor = anchor.getBoundingClientRect();

        const topPos = rectAnchor.top - rectParent.top;

        console.log('topPos', topPos);

        // console.log('parent 123', parent.getBoundingClientRect());
        // console.log('anchor 123', anchor.getBoundingClientRect());
        if (topPos > 0) {
          this.$emit('scrollTop', topPos);
          anchor.classList.add('blink');
        }
      }
    },
  },
  mounted() {
    console.log('nuttrema-index-list-content created and ready');
    if (this.scrollTargetID) this.findAnchorAndTriggerScroll();
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-index-list__content__list {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    flex: 1 1 auto;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-index-list-content.vue